import { useMemo } from "react";
import { DICTIONARY_GROUPS, VERSION_META } from "../../lib/dictionaryApi";

export default function DictionaryInput({
  selected,             
  onToggle,             
  version,              
  onChangeVersion,      
  onSubmit,             
  loading,              
}) {
  // 한국어 전용 데이터
  const groups = useMemo(() => DICTIONARY_GROUPS(), []);
  const versions = useMemo(() => VERSION_META(), []);

  return (
    <div className="dictionaryinput">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit?.();
        }}
      >
        {/* 증상 그룹 6개 — map 기반 */}
        {groups.map((g) => (
          <div className="form_section" key={g.key}>
            <h3 className="sectionTitle">{g.title}</h3>
            <div className="buttonbox">
              {g.items.map((item) => {
                const isActive = !!selected[g.key]?.has(item);
                return (
                  <button
                    type="button"
                    key={item}
                    className={`symptom ${isActive ? "active" : ""}`}
                    onClick={() => onToggle(g.key, item)}
                  >
                    {item}
                  </button>
                );
              })}
            </div>
          </div>
        ))}

        {/* 버전 선택 (기본/상세/전문가) */}
        <div className="submit_type">
          <div className="version-selector">
            {versions.map((v) => (
              <button
                key={v.value}
                type="button"
                className={`version-btn ${version === v.value ? "active" : ""}`}
                onClick={() => onChangeVersion(v.value)}
              >
                {v.label}
              </button>
            ))}
          </div>
        </div>

        {/* 제출 */}
        <div className="submit_button">
          <button type="submit" className="btn" disabled={loading}>
            {loading ? "분석 중..." : "AI 분석 결과 보기"}
          </button>
        </div>
      </form>
    </div>
  );
}
